import {forkJoin as observableForkJoin, Observable} from 'rxjs';
import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {AppConfigService} from './../../service/app-config.service';
import {RequestDataService} from './../../service/request-data.service';
import {UtilsService} from './../../service/utils.service';
import {ConfirmModalService} from './../../service/confirm-modal.service';
import * as _sh from 'lodash';
import * as _ from 'underscore';

@Component({
  selector: 'app-multi-poplist',
  templateUrl: './multi-poplist.component.html',
  styleUrls: ['./multi-poplist.component.scss']
})
export class MultiPoplistComponent implements OnInit {

  @Input() hulkForm: FormGroup;
  @Input() hulkColumn: any;

  @Output('selectModel') childFun = new EventEmitter();

  // 改变绑定对象
  @Input() bindModel: any;
  @Input() forms: any;
  @Input() oneForms: any;
  // 是否显示弹框
  public isVisible: boolean = false;

  @ViewChild('childForm', {static: false}) childForm;
  // 数据添加模式，
  public dataAdditionMode = "覆盖";

  public dataAdditionModeOption = [
    {
      "code": "added",
      "name": "新增"
    },
    {
      "code": "cover",
      "name": "覆盖"
    }
  ]

  // 绑定当前table的数组数据
  public dataSet: any = [];
  public totalDataSet: any = [];
  public selectedDataSet: any = [];

  // 当前table的表头
  public showColumns: any = [];

  // 查询对象
  public conditionColumns: any = {
    columns: []
  };
  private tag = true; // 判断是否弹出页面 选择

  // 查询数据
  public conditionList: any[] = [];

  public allChecked = false;
  public indeterminate = false;
  public conditions;
  // 分页下标
  public pageIndex: any = 1;
  // 每页显示数据
  public pageSize: any = this.appConfigService.config.pageCount;

  public nzPageSizeOptions: any = [10, 20, 30, 50, 100, 200]

  // 总条数
  public total: any = 1;

  constructor(private requestDataService: RequestDataService,
              private appConfigService: AppConfigService,
              private utils: UtilsService,
              private confirmModal: ConfirmModalService) {
  }

  // checkbox 选中或未选中之后刷新总checkbox的状态
  refreshStatus(data?): void {

    let selectedDataSet = [];
    if (this.utils.Base_HasValue(data)) {
      _sh.each(this.totalDataSet,oneOldRow=>{
        if (oneOldRow['code'] == data['code']) {
          oneOldRow['checked'] = data['checked'];
        }
      })
    }
    _sh.each(this.totalDataSet,oneOldRow=>{
      if (oneOldRow['checked']) {
        selectedDataSet.push(oneOldRow)
      }
    })
    this.selectedDataSet = selectedDataSet;

    const validData = this.dataSet.filter(value => !value.disabled);
    const allChecked = validData.length > 0 && validData.every(value => value.checked === true);
    const allUnChecked = validData.every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }

  // 将total选中数据和搜索彀中数据合并
  mergeTotalSelect() {
    _.each(this.totalDataSet, total => {
      const current = _.find(this.dataSet, data => total['code'] === data['code']);
      if (current) {
        total['checked'] = current['checked'];
      }
    });
  }

  checkAll(value: boolean): void {
    this.dataSet.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
    this.mergeTotalSelect();
  }

  // 合并查询条件
  transformCondition(columns) {
    let condition = [];
    _.each(columns, (item) => {
      if (this.utils.Base_HasValue(item['model'])) {
        /**
         * [obj 查询条件对象]
         * column 字段值对应数据库字段
         * label 标题
         * code 查询字段值
         * name 查询字段显示值用于字典
         * @type {Object}
         */
        let obj = {
          column: item['column'],
          title: item['lable'],
          code: item['model'],
          name: item['model'],
          component: item['component']
        };
        if (_.contains(['select', 'poplist', 'inputDataFilter'], item['component'])) {
          const selected = _.find(item['itemArray'], (v) => {
            return v['code'] === item['model'];
          });
          obj['name'] = selected['name'];
        } else if (_.contains(['multiSelect', 'multipopCondition'], item['component'])) {
          let nameList = [];
          _.each(item['itemArray'], (v) => {
            if (_.contains(item['model'], v['code'])) {
              nameList.push(v['name']);
            }
          });
          obj['name'] = nameList.join(' ');
        } else if (_.contains(['dateRange', 'dateTimeRange'], item['component'])) {
          obj['name'] = item['model'].join('~');
          obj['bindColumns'] = item['bindColumns'];
        }
        condition.push(obj);
      }
    });
    return condition;
  }

  //查找目标值
  findValue(pInsertValue, pErrormsg) {
    const that = this;

    function findTarget(targetTable, targetColum) {
      let tmpValues = null;
      for (let i = 0; i < that.forms.length; i++) {
        if (that.utils.Base_compare(that.forms[i].tablename, targetTable)) {
          tmpValues = that.utils.Base_getJsonValue(that.forms[i].data[0], targetColum, null);
          if (that.utils.Base_HasValue(tmpValues)) {
            break;
          }
        }
      }
      return tmpValues;
    }

    let tmp = pInsertValue;
    if (that.utils.Base_HasValue(pInsertValue)) {
      const targetParam = pInsertValue.split('.');
      if (_.isArray(targetParam)) {
        if (that.utils.Base_compare(targetParam[0], 'SYS')) {
          const targetTable = targetParam[1];
          const targetColum = targetParam[2];
          const tmpValues = findTarget(targetTable, targetColum);
          if (that.utils.Base_HasValue(tmpValues)) {
            tmp = tmpValues;
            that.tag = true;
          } else {
            that.confirmModal.show('warning', {
              'title': '温馨提示',
              'content': pErrormsg
            });
            that.tag = false;
            return false;
          }
        }
      }
    }
    return tmp;
  }

  makeConditions() {
    const dictionaryParam = this.utils.Base_getJsonValue(this.hulkColumn, 'dictionaryParam', null);
    let intputCondition = _sh.get(this.hulkColumn, 'inputCondition', null);
    let conditions = {};
    if (this.utils.Base_HasValue(dictionaryParam)) {
      _.each(this.hulkColumn.dictionaryParam, OneGroup => {
        const dicColumn = this.utils.Base_getJsonValue(OneGroup, 'column', null);
        const dicErrormsg = this.utils.Base_getJsonValue(OneGroup, 'errormsg', null);
        if (this.utils.Base_HasValue(dicColumn) && this.utils.Base_HasValue(dicErrormsg)) {
          const tmpValue = this.findValue(OneGroup['value'], OneGroup['errormsg']);
          if (this.utils.Base_HasValue(tmpValue)) {
            conditions[OneGroup['column']] = tmpValue;
          }
        }
      });
    }
    conditions = _.assign(conditions, intputCondition);
    if (this.utils.Base_HasValue(conditions)) {
      return conditions;
    } else {
      return null;
    }
  }

  /**
   *
   * @param reset 重置页码
   */
  searchFilter(reset: boolean = true) {
    this.conditionList = this.transformCondition(this.childForm._validateForm['columns']);
    let condition = {};
    _.each(this.conditionList, (item) => {
      // 如果是daterange 类型需要将字段从bindColumns中取出
      if (_.contains(['dateRange', 'dateTimeRange'], item['component'])) {
        _.each(item.code, (value, index) => {
          const column = item['bindColumns'][index];
          condition[column] = value;
        });
      } else {
        condition[item.column] = item.code;
      }
    });
    let intputCondition = _sh.get(this.hulkColumn, 'inputCondition', null);
    condition = _.assign(condition, intputCondition);
    condition = _.assign(condition, this.conditions);

    this.searchData(reset, condition);
  }

  resetFilter() {
    this.childForm.resetForm(); // 删除条件
    this.searchFilter(true); //
  }

  // 查询后的数据进行封装
  transformResult(data) {
    let dataSet = data.data || [];
    // 如果是修改。则之前选的数据要选中
    if (this.bindModel) {
      if (this.utils.Base_HasValue(this.bindModel[this.hulkColumn.column])) {
        _.each(dataSet, set => {
          if (this.bindModel[this.hulkColumn.column].indexOf(set['code']) > -1) {
            set['checked'] = true;
          }
        });
      }
    } else {
      if (this.utils.Base_HasValue(this.hulkColumn.model)) {
        _.each(dataSet, set => {
          if (this.hulkColumn.model.indexOf(set['code']) > -1) {
            set['checked'] = true;
          }
        });
      }
    }

    this.dataSet = dataSet;
    this.refreshStatus();
    this.showColumns = data.showColumns.columns || [];
    this.total = data.page.rowCount;
    this.pageIndex = data.page.pageNum;
  }

  // 将total选中数据和搜索彀中数据合并,
  mergeDataSelect(reset: boolean = false) {

    // reset = true 重置页码, 如果重置页码。 重新计算缓存数据
    // reset = false 重置页码, 如果重置页码，添加缓存数据。
    if (!reset) {
      this.totalDataSet = _sh.concat(this.totalDataSet,this.dataSet);
      this.totalDataSet = _sh.uniqBy(this.totalDataSet,'code');
    } else {
      _sh.each(this.dataSet,oneRow=>{
        oneRow['checked'] = false;
      })
      this.totalDataSet = this.dataSet;
      this.selectedDataSet = [];
    }

    _sh.each(this.totalDataSet,oneOldRow=>{
      _sh.each(this.dataSet, onnRow=> {
        if (onnRow['code'] == oneOldRow['code']) {
          onnRow['checked'] = oneOldRow['checked'];
        }
      })
    })
  }

  /**
   *
   * @param reset 重置页码
   * @param condition
   */
  searchData(reset: boolean = false, condition?: {}): void {
    if (reset) {
      this.pageIndex = 1;
    }
    this.requestDataService.getPaginationData(this.hulkColumn.dictionary, condition || {}, this.pageIndex, this.pageSize).subscribe((data: any) => {
      this.transformResult(data);
      this.mergeDataSelect(reset);
    });
  }

  // 移动数据 model - > data
  moveModelToData(): void {
    _.each(this.forms, OneGroup => {
      if (this.utils.Base_compare(OneGroup['type'], 'normal')) {
        if (!_.has(OneGroup, 'data')) {
          OneGroup['data'] = [];
        }
        OneGroup['data'][0] = {}; // 清空
        _.each(OneGroup['columns'], function (OneColumn) {
          OneGroup['data'][0][OneColumn['column']] = OneColumn['model'];
        });
      } else {
        const oneForm = this.oneForms;
        if (this.utils.Base_compare(OneGroup['tablename'], oneForm.tablename)) {
          if (!_.has(OneGroup, 'data')) {
            OneGroup['data'] = [];
          }
          OneGroup['data'][0] = {}; // 清空
          _.each(oneForm.columns, function (OneColumn) {
            OneGroup['data'][0][OneColumn['column']] = OneColumn['model'];
          });
        }
      }
    });
  }

  showModal() {
    if (this.hulkColumn.disable) {
      return false;
    }
    this.moveModelToData(); // 移动数据 model - > data
    this.conditions = this.makeConditions();
    if (this.tag) {
      const parallel$ = observableForkJoin(
        this.requestDataService.getPaginationData(this.hulkColumn.dictionary, this.conditions, this.pageIndex, this.pageSize),
        this.requestDataService.getConditionData(this.hulkColumn.dictionary)
      );
      parallel$.subscribe(
        values => {
          let dataObject = values[0];
          let itemData = dataObject['data'] || [];
          if (this.utils.Base_HasValue(itemData)) {
            if (this.utils.Base_HasValue(this.hulkColumn.itemArray)) {
              _.each(this.hulkColumn.itemArray, (item) => {
                let oneData = _.find(itemData, (value) => {
                  return item['code'] === value['code'];
                });
                if (this.utils.Base_HasValue(oneData)) {
                  itemData = _.without(itemData, oneData);
                }
              });
              this.hulkColumn.itemArray = this.hulkColumn.itemArray.concat(itemData);
            } else {
              this.hulkColumn.itemArray = itemData;
            }
          }
          this.conditionColumns = values[1]['conditionColumns'][0] || {};
          this.conditionColumns.needInit = true;
          this.transformResult(dataObject);
          this.isVisible = true;
          this.dataAdditionMode = 'added';
          // 缓存所有数据
          _sh.each(this.dataSet,oneRow=>{
            oneRow['checked'] = false;
          })
          this.totalDataSet = this.utils.DeepCopy(this.dataSet);
          this.selectedDataSet = [];

        }
      );
    }
  }

  removeValue() {
    if (!this.hulkColumn.disable) {
      if (this.bindModel) {
        this.bindModel[this.hulkColumn.column] = null;
        this.bindModel[this.hulkColumn.column + 'Name'] = '';
      } else {
        this.hulkColumn.model = null;
        this.hulkColumn.modelName = '';
      }
      // 判断columnGroup
      if (this.utils.Base_HasValue(this.hulkColumn['columnGroup']) && this.hulkColumn['columnGroup'].length > 0) {
        _.each(this.hulkColumn.columnGroup, oneData => {
          oneData['model'] = null;
        });
      }
    }
  }


  // 多选点击确定按钮事件
  selectMulti() {
    let modelList = [];
    let nameList = [];
    let choiceObjects = [];
    _.each(this.selectedDataSet, (item) => {
      modelList.push(item['code']);
      nameList.push(item['name']);
      choiceObjects.push(item);
    });
    if (this.hulkColumn.limitLength && modelList.length > this.hulkColumn.limitLength) {
      this.confirmModal.show('warning', {
        title: '温馨提示',
        content: '最多选择' + this.hulkColumn.limitLength + '条数据'
      });
      return;
    }
    if (this.hulkColumn.component === 'multipopCondition') {
      if (this.bindModel) {
        this.bindModel[this.hulkColumn.column] = modelList;
      } else {
        this.hulkColumn.model = modelList;
      }
    } else {
      if (this.bindModel) {
        this.bindModel[this.hulkColumn.column] = modelList.join(',');
      } else {
        if (this.dataAdditionMode == 'added') {
          let arr01 = modelList;
          if (this.utils.Base_HasValue(this.hulkColumn.model)) {
            arr01 = _sh.concat(arr01,this.hulkColumn.model.split(','));
            arr01 = this.utils.Base_ArrayDelEmptyAndUniq(arr01);
          }
          this.hulkColumn.model = arr01.join(',');

        } else {
          this.hulkColumn.model = modelList.join(',');
        }
      }
    }
    if (this.bindModel) {
      this.bindModel[this.hulkColumn.column + 'Name'] = nameList.join(',');
    } else {

      if (this.dataAdditionMode == 'added') {
        let arr01 = nameList;
        if (this.utils.Base_HasValue(this.hulkColumn.modelName)) {
          arr01 = _sh.concat(arr01, this.hulkColumn.modelName.split(','));
          arr01 = this.utils.Base_ArrayDelEmptyAndUniq(arr01);
        }
        this.hulkColumn.modelName = arr01.join(',');
      } else {
        this.hulkColumn.modelName = nameList.join(',');
      }

    }
    if (this.hulkColumn.columnGroup) {
      _.each(this.hulkColumn.columnGroup, oneGroup => {
        let fromValue = oneGroup['fromValue'];
        let values = [];
        _.each(choiceObjects, item => {
          values.push(item[fromValue]);
        });

        if (this.dataAdditionMode == 'added') {
          let arr01 = [];
          arr01 = _sh.concat(values,oneGroup['model']);
          arr01 = this.utils.Base_ArrayDelEmptyAndUniq(arr01);
          oneGroup['model'] = arr01.join(',');
        } else {
          oneGroup['model'] = values.join(',');
        }
      });
    }
    this.isVisible = false;
    this.childFun.emit({
      modelList: _.filter(this.dataSet, item => item['checked'])
    });
  }

  ngOnInit() {
    this.hulkColumn.lableSpan = this.hulkColumn.lableSpan || 9;
    this.hulkColumn.itemSpan = this.hulkColumn.itemSpan || 15;
  }

  // 监听model值得改变
  ngDoCheck(): void {
    if (this.bindModel) {
      if (this.bindModel[this.hulkColumn.column] !== this.bindModel['old' + this.hulkColumn.column]) {
        if (this.utils.Base_HasValue(this.bindModel[this.hulkColumn.column])) {
          if (this.hulkColumn.itemArray && this.hulkColumn.itemArray.length) {
            let nameList = [];
            _.each(this.hulkColumn.itemArray, (item) => {
              if (this.hulkColumn.component === 'multipopCondition') {
                if (_.contains(this.bindModel[this.hulkColumn.column], item['code'])) {
                  nameList.push(item['name']);
                }
              } else {
                if (this.bindModel[this.hulkColumn.column].indexOf(item['code']) >= 0) {
                  nameList.push(item['name']);
                }
              }

            });
            this.bindModel[this.hulkColumn.column + 'Name'] = nameList.join(' ');
          }
        }
        this.bindModel['old' + this.hulkColumn.column] = this.bindModel[this.hulkColumn.column];
      }
    } else {
      if (this.hulkColumn.model !== this.hulkColumn.oldModel) {
        if (this.utils.Base_HasValue(this.hulkColumn.model)) {
          if (this.hulkColumn.itemArray && this.hulkColumn.itemArray.length) {
            let nameList = [];
            _.each(this.hulkColumn.itemArray, (item) => {
              if (this.hulkColumn.component === 'multipopCondition') {
                if (_.contains(this.hulkColumn.model, item['code'])) {
                  nameList.push(item['name']);
                }
              } else {
                if (this.hulkColumn.model.indexOf(item['code']) >= 0) {
                  nameList.push(item['name']);
                }
              }

            });
            this.hulkColumn.modelName = nameList.join(',');
          }
        }
        this.hulkColumn.oldModel = this.hulkColumn.model;
      }
    }
  }

  modelChange($event: any) {
  }
}
